// @flow

const DATE_VALIDATOR: 'date' = 'date';
const EMAIL_VALIDATOR: 'email' = 'email';
const PHONE_VALIDATOR: 'phone' = 'phone';
const REQUIRED_VALIDATOR: 'required' = 'required';
const SELECT_LENGTH_VALIDATOR: 'selectLength' = 'selectLength';

export {
  DATE_VALIDATOR,
  EMAIL_VALIDATOR,
  PHONE_VALIDATOR,
  REQUIRED_VALIDATOR,
  SELECT_LENGTH_VALIDATOR,
};

export type Validators = typeof DATE_VALIDATOR |
  typeof EMAIL_VALIDATOR |
  typeof PHONE_VALIDATOR |
  typeof REQUIRED_VALIDATOR |
  typeof SELECT_LENGTH_VALIDATOR;

export default null;
